import * as Sentry from '@sentry/nuxt'

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // tracesSampleRate: 1.0,
    // debug: true,
  })
}
